import COMPANIES from "./ListCompany";


class MyUtils {
    formatSelectedLocations(locations) {
        if(locations == null) return null;
        if(locations.length === 0) return null;
        var value = "";
        var i = 1;
        locations.forEach(l => {
            value = value + l;
            if(i < locations.length){
                value = value + ";"
            }
            i++;
        })

        return value;
    }

    formatFieldItemsForEvent(fields) {
        if(fields == null) return null;
        if(fields.length === 0) return null;
        var value = "";
        var i = 1;
        fields.forEach(l => {
            value = value + l;
            if(i < fields.length){
                value = value + ";"
            }
            i++;
        })

        return value;
    }


}

let UTILS = new MyUtils();

export default UTILS


// WEBPACK FOOTER //
// ./src/services/utils.js